import React from 'react';
import styled from 'styled-components';

const Spacer = styled(({ className, ...props }) => <div className={className} />)`
   flex: 1 0 0;
`;

export default Spacer;
